module.exports = __webpack_public_path__ + "c36e1e230f3ffc30f317ebe3946062f9.svg";